import React, { FunctionComponent, useContext } from 'react'
import { Form, Select, Space } from 'antd'
import { useLoaderData, useMatch } from '@tanstack/react-router'
import { arrayToMap } from '../../../../utils/data'
import { Vehicle } from 'server'
import { useMap } from '@vis.gl/react-google-maps'
import { MapSettingsContext } from '../../../../contexts/MapSettingsContext'
import MapSettingsContextInterface from '../../../../contexts/MapSettingsContext/MapSettingsContextInterface'
import useDefaultVehicleFilter from '../../../../hooks/data/useDefaultVehicleFilter'

const DeviceSearch: FunctionComponent<any> = () => {
  const match = useMatch({ strict: false })
  const { vehicles, vehicleLocations } = useLoaderData({ from: match.routeId ?? '/' })

  const { setSelectedVehicleId } = useContext(MapSettingsContext) as MapSettingsContextInterface

  const map = useMap()

  const [form] = Form.useForm()

  const filteredVehicleLocations = useDefaultVehicleFilter(vehicles, vehicleLocations)

  const vehicleLocationMap = arrayToMap(filteredVehicleLocations, 'vehicle_id')

  const handleClick = (vehicleId: number) => {
    const vehicleLocation = vehicleLocationMap.get(vehicleId)
    const latLng = new google.maps.LatLng(vehicleLocation?.latitude, vehicleLocation?.longitude)
    // setSelectedVehicleId(vehicleId)
    map?.panTo(latLng)
    const zoom = map?.getZoom()
    if (zoom) {
      if (zoom < 15) {
        map?.setZoom(15)
      }
    }
  }

  const options = vehicles
    .filter((vehicle: Vehicle) => vehicleLocationMap.has(vehicle.vehicle_id))
    .sort((vehicleA: Vehicle, vehicleB: Vehicle) => vehicleA.name.localeCompare(vehicleB.name))
    .map((vehicle: Vehicle) => {
      return { label: vehicle.name, value: vehicle.vehicle_id }
    })

  return (
    <Space>
      <Form form={form} style={{ padding: 0, margin: 0 }}>
        <Form.Item name={'search'} style={{ padding: 0, margin: 0 }}>
          <Select
            onClear={() => setSelectedVehicleId(undefined)}
            allowClear={true}
            style={{ width: '300px' }}
            placeholder={'Search devices'}
            options={options}
            showSearch={true}
            filterOption={(input, option) =>
              (option?.label ?? '').toString().toLowerCase().includes(input.toLowerCase())
            }
            onSelect={handleClick}
          />
        </Form.Item>
      </Form>
    </Space>
  )
}

export default DeviceSearch
